import { graphql } from '@/gql'

export const COMPANY_SETTINGS_QUERY = graphql(`
  query allCompanySettings($filter: CompanySettingFilter) {
    companySettings(filter: $filter) {
      edges {
        node {
          id
          companyId
          key
          value
          valueBoolean
          valueStorage {
            id
            url
          }
        }
      }
    }
  }
`)

export const COMPANY_SETTING_BY_KEY = graphql(`
  query companySettingByKey($companyId: UUID!, $key: CompanySettingKey!) {
    companySettingByCompanyIdAndKey(companyId: $companyId, key: $key) {
      id
      companyId
      key
      value
      valueBoolean
      valueStorage {
        id
        url
      }
    }
  }
`)
